import type { MumulLiveProfileStatus } from 'shared/src/api';

export type MumulLiveStatusDisplay = {
  ringColor: string;
  dotColor: string;
  text: string;
  textColor: string;
};

/**
 * 상품상세(PDP) 무물라이브 프로필 — 변형군 B(간판 행) 상태별 표시 정보.
 * (마켓홈 #2039 와 디자인이 달라 PDP 전용 값으로 둔다. DEFAULT 는 미노출이라 제외)
 */
const MUMUL_LIVE_STATUS_DISPLAY: Record<
  Exclude<MumulLiveProfileStatus, 'DEFAULT'>,
  MumulLiveStatusDisplay
> = {
  LIVE: {
    ringColor: '#EC0000',
    dotColor: '#EC0000',
    text: '무물라이브 중',
    textColor: '#EC0000',
  },
  HAS_UNREAD_STORY: {
    ringColor: '#006AFF',
    dotColor: '#2572F7',
    text: '새로운 스토리가 올라왔어요',
    textColor: '#777777',
  },
  ALL_READ_STORY: {
    ringColor: '#CCCCCC',
    dotColor: '#2572F7',
    text: '최근 스토리 보기',
    textColor: '#777777',
  },
};

/**
 * 상태값에 해당하는 표시 정보를 반환한다. DEFAULT 이거나 없으면 null.
 */
export const getMumulLiveStatusDisplay = (
  status: MumulLiveProfileStatus | null | undefined,
): MumulLiveStatusDisplay | null => {
  if (status == null || status === 'DEFAULT') {
    return null;
  }
  return MUMUL_LIVE_STATUS_DISPLAY[status];
};
